import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import _ from "lodash";
import {
  fetchRolePlayData,
  fetchRolePlayDataClear,
  getRolePlayRecordedDetail,
  getRolePlayRecordedDetailClear,
} from "../../../redux/roleplay/actions";
import {
  rolePlayStatus,
  SessionKeys,
  starRatingCaptions,
} from "../../../utils/AppUtils";
import VideoPlayer from "react-video-js-player";
import { Spinner } from "react-bootstrap";
import { Rating } from "@mui/material";
import StarIcon from "@mui/icons-material/Star";
import SolutionModal from "../../RolePlay/SolutionModal";
import Loader from "../../Loader/Loader";
import FormButtonComponent from "../FormControl/FormButton/FormButtonComponent";
import TitleTagsComponent from "../Misc/TitleTags/TitleTagsComponent";

const MyRolePlayReviewDetailComponent = ({
  role_type,
  submitId,
  setShowVideo,
}) => {
  const [productData, setProductData] = useState("");

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { roleplayId } = useParams();

  const [rubricData, setRubricData] = useState([]);

  const rpDetailData = useSelector((state) => state.rolePlay.recordedDetail);
  const rpWpData = useSelector((state) => state.rolePlay.rolePlayData);
  const [isLoading, setIsLoading] = useState(true);
  const [loaderMsg, setLoaderMsg] = useState("");
  const [modalShow, setModalShow] = useState(false);
  const [solutionData, setSolutionData] = useState({});
  const [selectedSolution, setSelectedSolution] = useState({});
  const [formTextArea, setFormTextArea] = useState("");
  const [recordedURL, setRecordedURL] = useState("");

  const navigateToListing = () => {
    navigate("/learn/roleplay");
  };

  useEffect(() => {
    console.log("rpwpDa", rpWpData);
    if (!_.isEmpty(rpWpData)) {
      if (rpWpData?.status === "success") {
        setRubricData(rpWpData?.payload?.payload?.rubric_data);
      }
    }
  }, [rpWpData]);

  const [tagsArr, setTagsArr] = useState([]);
  const reviewedDateConverter = (date1) => {
    if (date1) {
      const timestamp = date1 * 1000;

      const date = new Date(timestamp);
      const options = { year: "numeric", month: "short", day: "numeric" };

      const formattedDate = date.toLocaleDateString("en-US", options);
      return formattedDate;
    }
  };

  useEffect(() => {
    if (!_.isEmpty(rpDetailData)) {
      console.log("rpde---", rpDetailData);
      if (rpDetailData?.status === "success") {
        let rp = rpDetailData?.payload?.payload;
        tagsArr.length = 0;
        tagsArr.push(rp?.uploaded_type === "audio" ? "Audio" : "Video");
        tagsArr.push(
          rp?.submission_date ? reviewedDateConverter(rp?.submission_date) : ""
        );
        if (rp?.recorded_duration) {
          let time = rp?.recorded_duration;
          let parts = time.split(":");
          let minutes = parts[0];
          let seconds = parts[1];
          tagsArr.push(`${minutes}m ${seconds}s`);
        }
        // setTagsArr(tagsArr);
        setProductData(rpDetailData?.payload?.payload);
        setRecordedURL(rpDetailData?.payload?.payload?.recorded_url);
        setRubricData(rpDetailData?.payload?.payload?.rubric_data);

        setIsLoading(false);
      }
      dispatch(fetchRolePlayDataClear());
      dispatch(getRolePlayRecordedDetailClear());
    }
  }, [rpDetailData]);

  const [rating, setRating] = useState({});
  const handleRatingChange = (item, newValue) => {
    setRating((prevRatings) => ({
      ...prevRatings,
      [item]: newValue, // test rating
    }));
  };

  const sendFeedback = () => {};

  const fetchRolePlayDetail = () => {
    dispatch(
      fetchRolePlayData({
        module: "getRolePlayDetail",
        postData: {
          token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
          id: roleplayId,
        },
      })
    );
  };

  useEffect(() => {
    console.log("data--", rpWpData);
    if (!_.isEmpty(rpWpData)) {
      if (rpWpData.status === "success") {
        const payload = rpWpData.payload.payload;
        // if (type != 'review')
        dispatch(
          getRolePlayRecordedDetail({
            module: "getroleplayrecordeddetail",
            postData: {
              token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
              id: payload?.rp_mid,
              type: role_type,
              submit_id: submitId,
            },
          })
        );
        return () => {
          dispatch(getRolePlayRecordedDetailClear());
          dispatch(fetchRolePlayDataClear());
        };
      }
    }
  }, [rpWpData]);

  useEffect(() => {
    console.log("recorded url--", recordedURL);
  }, [recordedURL]);

  useEffect(() => {
    setIsLoading(true);
    setRecordedURL("");
    fetchRolePlayDetail();
  }, [roleplayId, submitId]);

  const renderRecordPlayerArea = () => {
    console.log("recorded url in videoplayer", recordedURL);
    return (
      <div>
        <VideoPlayer
          id={`roleInfo-${productData.roleplay_id}`}
          controls={true}
          src={recordedURL}
          width="720"
          height="420"
          autoPictureInPicture={false}
          fluid={true}
          inline={false}
          pictureInPictureToggle={false}
          // poster={productData.bannerURL}
          textTrackSettings={false}
          type={
            productData.recorded_url.includes(".mp4")
              ? "video/mp4"
              : "application/x-mpegURL"
          }
        />
      </div>
    );
  };

  return (
    <>
      <Loader start={isLoading} msg={loaderMsg} />
      {_.isEmpty(productData) && !isLoading ? (
        <img
          id="idRolePlayMyResponse"
          width={800}
          src="/images/myResponse.png"
          alt=""
        />
      ) : (
        // <RPReviewDetailBodyComponent
        //   id={roleplayId}
        //   title={roleplayDetail?.title}
        //   logoURL={""}
        //   logoAltText={"RP"}
        //   tagsArray={[]}
        //   description={roleplayDetail?.description}
        //   productData={roleplayDetail}
        //   isLoading={isLoading}
        //   setIsLoading={setIsLoading}
        //   setLoaderMsg={setLoaderMsg}
        //   rpData={""}
        //   type={role_type}
        //   role_type={role_type}
        //   rubricData={rubricData}
        // />
        <>
          <FormButtonComponent
            btnName="Back"
            leftIcon=""
            rightIcon=""
            isPrimary={false}
            replaceClassName="startcourse-btn"
            btnAction={() => setShowVideo(true)}
          />
          <div className="overview-row d-flex mt-3 gap-3 align-items-center">
            <div className="overview-title">Status{"   "} </div>
            <div className="roleplay-status">
              {rolePlayStatus(
                productData?.feedback_status
                  ? "feedback_received"
                  : "pending_review"
              )}
            </div>
          </div>
          <div className="learn-discuss-section">
            {!_.isEmpty(productData) && (
              <>
                {/* <div className="video-roleplay">
                  <VideoPlayer
                     id={`roleInfo-${productData.roleplay_id}`}
                    controls={true}
                    src={productData.recorded_url}
                    width="720"
                    height="420"
                    autoPictureInPicture={false}
                    fluid={true}
                    inline={false}
                    pictureInPictureToggle={false}
                    // poster={productData.bannerURL}
                    textTrackSettings={false}
                    type={
                      productData.recorded_url.includes(".mp4")
                        ? "video/mp4"
                        : "application/x-mpegURL"
                    }
                  />
                </div> */}
                <div className={recordedURL ? "" : "d-none"}>
                  {recordedURL ? renderRecordPlayerArea() : ""}
                </div>
                {role_type === "reviewed" ? (
                  ""
                ) : (
                  <div className="overview-row asgapbtm d-flex align-items-center mt-3 gap-3">
                    <div className="overview-title">Participant Name</div>
                    <div className="usernamewimg">
                      <img
                        className="userimgrolefg"
                        src="https://realtorsuccessfrontity-dev.niit-mts.com/wp-content/uploads/2022/12/shradesh-9@mailinator.com-20221229040622.png"
                      />
                      {productData?.participator_name}
                    </div>
                  </div>
                )}
                <div className="overview-card-section mt-3">
                  <div className="overview-row">
                    <div className="meta-lsit">
                      <TitleTagsComponent tagsArray={tagsArr} />
                    </div>
                  </div>
                </div>
                <div className="overview-card-section mt-3">
                  <div className="overview-row">
                    <h5 className="headfrf">
                      {role_type === "reviewed"
                        ? "Comments from you"
                        : "Comments from the participant"}
                    </h5>
                    <div className="d-flex ratings-role">
                      {productData?.participator_comment
                        ? productData?.participator_comment
                        : "-"}
                    </div>
                  </div>
                </div>

                <div className="sentiment-wrapper mt-5">
                  <div className="sentimant-box">
                    <p className="setimatetitle">Sentiment Analysis</p>
                    <div className="d-flex ratings-role mt-2">
                      <div className="rolerate">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="40"
                          height="40"
                          viewBox="0 0 40 40"
                          fill="none"
                        >
                          <path
                            d="M17.4163 25.8333C18.083 26.5 18.9441 26.8264 19.9997 26.8125C21.0552 26.7986 21.833 26.4167 22.333 25.6667L31.6663 11.6667L17.6663 21C16.9163 21.5 16.5205 22.2639 16.4788 23.2917C16.4372 24.3194 16.7497 25.1667 17.4163 25.8333ZM19.9997 6.66666C21.6386 6.66666 23.215 6.89582 24.7288 7.35416C26.2427 7.81249 27.6663 8.49999 28.9997 9.41666L25.833 11.4167C24.9163 10.9444 23.965 10.5903 22.9788 10.3542C21.9927 10.118 20.9997 9.99999 19.9997 9.99999C16.3052 9.99999 13.1594 11.2986 10.5622 13.8958C7.96495 16.493 6.66634 19.6389 6.66634 23.3333C6.66634 24.5 6.82606 25.6528 7.14551 26.7917C7.46495 27.9305 7.91634 29 8.49968 30H31.4997C32.1386 28.9444 32.6038 27.8472 32.8955 26.7083C33.1872 25.5694 33.333 24.3889 33.333 23.1667C33.333 22.1667 33.215 21.1944 32.9788 20.25C32.7427 19.3055 32.3886 18.3889 31.9163 17.5L33.9163 14.3333C34.7497 15.6389 35.4094 17.0278 35.8955 18.5C36.3816 19.9722 36.6386 21.5 36.6663 23.0833C36.6941 24.6667 36.5136 26.1805 36.1247 27.625C35.7358 29.0694 35.1663 30.4444 34.4163 31.75C34.1108 32.25 33.6941 32.6389 33.1663 32.9167C32.6386 33.1944 32.083 33.3333 31.4997 33.3333H8.49968C7.91634 33.3333 7.36079 33.1944 6.83301 32.9167C6.30523 32.6389 5.88856 32.25 5.58301 31.75C4.86079 30.5 4.30523 29.1736 3.91634 27.7708C3.52745 26.368 3.33301 24.8889 3.33301 23.3333C3.33301 21.0278 3.77051 18.868 4.64551 16.8542C5.52051 14.8403 6.71495 13.0764 8.22884 11.5625C9.74273 10.0486 11.5136 8.85416 13.5413 7.97916C15.5691 7.10416 17.7219 6.66666 19.9997 6.66666Z"
                            fill="black"
                          />
                        </svg>
                        <div className="sentimte-rate-box">
                          <strong>{productData?.recorded_wpm}</strong>
                          <span className="wordtext">Words per minute</span>
                        </div>
                      </div>
                      <div className="rolerate">
                        🙂
                        <div className="sentimte-rate-box">
                          <strong>
                            {productData?.recorded_sentiment_positive}%
                          </strong>
                          <span className="wordtext">Good</span>
                        </div>
                      </div>
                      <div className="rolerate">
                        😐
                        <div className="sentimte-rate-box">
                          <strong>
                            {" "}
                            {productData?.recorded_sentiment_neutral}%
                          </strong>
                          <span className="wordtext">Neutral</span>
                        </div>
                      </div>
                      <div className="rolerate">
                        🙁
                        <div className="sentimte-rate-box">
                          <strong>
                            {" "}
                            {productData?.recorded_sentiment_negative}%
                          </strong>
                          <span className="wordtext">Poor</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {role_type === "reviewed" && !productData?.feedback_status ? (
                  ""
                ) : (
                  <div className="row">
                    <div className="review-box-table">
                      {rubricData?.map((item) => {
                        return (
                          <div className="review-rating-sub-box">
                            <div className="rating-title-box">{item}</div>
                            <div className="start-rating-box">
                              {productData?.feedback_status ? (
                                <Rating
                                  name={productData}
                                  precision={0.5}
                                  max={3}
                                  readOnly
                                  value={
                                    productData?.feedback_info?.rating_provided[
                                      item
                                    ]
                                  }
                                  onChangeActive={(event, newHover) => {}}
                                  emptyIcon={
                                    <StarIcon
                                      style={{ opacity: 0.55 }}
                                      fontSize="inherit"
                                    />
                                  }
                                />
                              ) : (
                                <Rating
                                  name={productData}
                                  precision={0.5}
                                  max={3}
                                  onChange={(event, newValue) => {
                                    // formik.setFieldValue(
                                    //   `rating[${data}]`,
                                    //   newValue
                                    // );
                                    handleRatingChange(item, newValue);
                                  }}
                                  onChangeActive={(event, newHover) => {}}
                                  emptyIcon={
                                    <StarIcon
                                      style={{ opacity: 0.55 }}
                                      fontSize="inherit"
                                    />
                                  }
                                />
                              )}
                            </div>
                            {productData?.feedback_status && (
                              <div className="reviewed-text">
                                {starRatingCaptions(
                                  _.toNumber(
                                    productData?.feedback_info?.rating_provided[
                                      item
                                    ]
                                  )
                                )}
                              </div>
                            )}
                          </div>
                        );
                      })}
                    </div>
                  </div>
                )}
                {role_type === "reviewed" && !productData?.feedback_status ? (
                  ""
                ) : (
                  <div className="row mt-3">
                    <div className="col-md-12">
                      {productData?.feedback_status ? (
                        <div className="overview-card-section">
                          <div className="overview-row">
                            <h5 className="headfrf">
                              {role_type === "reviewed"
                                ? "Comments from coach"
                                : "Your Comments"}
                            </h5>
                            <div className="d-flex ratings-role">
                              {productData?.feedback_info?.reviewer_comment
                                ? productData?.feedback_info?.reviewer_comment
                                : "-"}
                            </div>
                          </div>
                        </div>
                      ) : (
                        role_type == "review" && (
                          <div className="form-role-sec">
                            <div className="input-text position-relative">
                              <label
                                htmlFor="date_join"
                                className="input__label"
                              >
                                Attach comment to role play
                              </label>
                              <textarea
                                name="Addtional_Comments"
                                className="input__field commentfield"
                                rows="4"
                                cols="50"
                                placeholder="Enter comment..."
                                onChange={(e) => {
                                  setFormTextArea(e.target.value);
                                }}
                                value={formTextArea}
                              ></textarea>
                              <span className="roleplay-liner">
                                The reviewee will see these comments along with
                                the response itself.
                              </span>
                            </div>
                          </div>
                        )
                      )}
                    </div>
                  </div>
                )}
                {role_type === "review" && !productData?.feedback_status ? (
                  <div className="overview-row mt-3">
                    {!_.isEmpty(productData.solution_data) && (
                      <>
                        <h5 className="headfrf">
                          Suggested Solution
                          {productData?.solution_data?.length > 1 ? "s" : ""}
                        </h5>
                        <span className="overview-row">
                          {productData?.solution_data?.map((item) => {
                            return (
                              <div className="row">
                                <div className="select-status">
                                  <div className="form-check cursor-pointer">
                                    <input
                                      className="form-check-input cursor-pointer"
                                      type="radio"
                                      name="solutionRadio"
                                      value={item?.add_v_title}
                                      onChange={() => setSelectedSolution(item)}
                                    />
                                    <label
                                      className="form-check-label cursor-pointer"
                                      for="termofusein"
                                      onClick={() => {
                                        setModalShow(true);
                                        setSolutionData({
                                          title: item.add_v_title,
                                          type: item.add_v_type,
                                          url: item.add_v_link,
                                        });
                                      }}
                                    >
                                      {item?.add_v_title} (click to play)
                                    </label>
                                  </div>
                                </div>
                              </div>
                            );
                          })}
                        </span>
                      </>
                    )}
                  </div>
                ) : role_type === "reviewed" &&
                  productData?.feedback_status &&
                  !_.isEmpty(productData?.feedback_info?.solution_provided) ? (
                  <div className="overview-row mt-3">
                    <h5 className="headfrf">Suggested Solution</h5>
                    <span className="overview-row">
                      <div className="row">
                        <div className="select-status">
                          <div className="form-check cursor-pointer">
                            <label
                              className="form-check-label cursor-pointer"
                              for="termofusein"
                              onClick={() => {
                                setModalShow(true);
                                setSolutionData({
                                  title:
                                    productData?.feedback_info
                                      ?.solution_provided.add_v_title,
                                  type: productData?.feedback_info
                                    ?.solution_provided.add_v_type,
                                  url: productData?.feedback_info
                                    ?.solution_provided.add_v_link,
                                });
                              }}
                            >
                              {
                                productData?.feedback_info?.solution_provided
                                  .add_v_title
                              }{" "}
                              (click to play)
                            </label>
                          </div>
                        </div>
                      </div>
                    </span>
                  </div>
                ) : (
                  ""
                )}
                {role_type === "reviewed" ? (
                  ""
                ) : role_type === "review" && !productData.feedback_status ? (
                  <div className="row">
                    <div className="col-md-12">
                      <div className="role_frm_upload_btn edit_btn d-flex">
                        <button
                          className="btn-primary"
                          onClick={() => sendFeedback()}
                        >
                          {false ? (
                            <Spinner
                              as="span"
                              animation="border"
                              size="sm"
                              role="status"
                              aria-hidden="true"
                              variant="primary"
                            />
                          ) : (
                            <>Send Feedback</>
                          )}
                        </button>
                      </div>
                    </div>
                  </div>
                ) : (
                  ""
                )}
              </>
            )}
          </div>
        </>
      )}
      <SolutionModal
        show={modalShow}
        setShow={setModalShow}
        solutionData={solutionData}
        setSolutionData={setSolutionData}
      />
    </>
  );
};

export default MyRolePlayReviewDetailComponent;
